import generalApi from "@/services/general-api";

import { createStore, useStore } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const certCheckoutSlice = createStore(
	persist(
		(set) => ({
			isAppCheckout: false,
			checkoutInfo: null,
			fetchCheckoutInfo: async (eventregform_id) => {
				const checkoutInfo = await generalApi.getProfessionalCertCheckoutDetail(eventregform_id);
				set({ checkoutInfo });
				return checkoutInfo;
			},
			setIsAppCheckout: (isAppCheckout) => set({ isAppCheckout }),
			clearCheckoutInfo: () => set({ checkoutInfo: {} }),
		}),
		{
			name: "professional-cert-checkout", // name of the item in the storage (must be unique)
			storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
		},
	),
);
export const useCertCheckout = (selector = (state) => state) =>
	useStore(certCheckoutSlice, selector);
